export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const EDIT_CATEGORY = 'EDIT_CATEGORY'
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY'
export const LOADING_CATEGORY = 'LOADING_CATEGORY'